export const PlayerBackgroundComponent = () => {
  return null;
};
